module.exports = __webpack_public_path__ + "static/media/10-8.586481df.mp3";